import { Button, Icon, Tooltip2 } from '@tencent/udesign/dist';
import classNames from 'classnames';
import {
  FILTER_TIP_TEXT,
  FILTER_TRIGGER_BTN_TEXT,
  FILTER_TRIGGER_REST_TEXT,
  isFilterSelected,
} from '../../libs';

export const renderFilterDefaultIcon = () => {
  return <Icon icon="mdi-filter" />;
};

export const renderFilterTriggerNode = (
  callback: (
    action: 'reset' | 'ok',
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void
) => {
  const onClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    callback('ok', e);
  };
  const onClickReset = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    callback('reset', e);
  };
  return (
    <div className="footer-btns webkit-box flex-center">
      <Button type="default" onClick={onClickReset} size="tiny">
        {FILTER_TRIGGER_REST_TEXT}
      </Button>
      <Button type="primary" onClick={onClick} size="tiny">
        {FILTER_TRIGGER_BTN_TEXT}
      </Button>
    </div>
  );
};

export const renderFilterLabel = (
  icon: React.ReactNode,
  value: string | string[]
) => {
  const className = classNames('action-icon', {
    on: isFilterSelected(value),
  });
  return (
    <Tooltip2 title={FILTER_TIP_TEXT}>
      <div className={className}>{icon ? icon : renderFilterDefaultIcon()}</div>
    </Tooltip2>
  );
};

export const renderFilterLayerWrap = (
  children: React.ReactNode,
  callback: (
    action: 'reset' | 'ok',
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void
) => {
  return (
    <div className="filter-layer">
      <div className="filter-layer-body scrollable-default">{children}</div>
      {renderFilterTriggerNode(callback)}
    </div>
  );
};

export const renderFilterBoxSlot = (
  children: React.ReactNode,
  hasValue: boolean
) => {
  return (
    <div
      className={classNames('table-filter-box', {
        ['table-filter-box-has-val']: hasValue,
      })}
    >
      {children}
    </div>
  );
};
